import * as TK from 'components/Header/Menus/CountryMenu/translations/menus.locale.constants';

export const CountryMenusCommonLocale = {
  [TK.CANADA]: 'Canada',
  [TK.QATAR]: 'Qatar',
  [TK.UAE]: 'United Arab Emirates',
  [TK.USA]: 'United States',
  [TK.COUNTRY_TITLE]: 'The recipient’s country',
};
